// Modules
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// Components
import ColumnsItem from "./columnsItem";

// Styles
import * as styles from "./columns.module.scss";

const ColumnsRow = ({ arr, linksArray, type, border, amountInRow }) => {
  return (
    <div
      className={cx({
        [styles.columnsRow]: amountInRow === 3,
        [styles.columnsTwoRow]: amountInRow === 2,
      })}
    >
      {arr.map(
        (
          {
            button,
            hideNumber,
            icon,
            _key,
            numberColor,
            numberIcon,
            substring,
            title,
            titleColor,
          },
          i
        ) => {
          const isBorder = border ? i + 1 < arr.length : false;

          return (
            <ColumnsItem
              isBorder={isBorder}
              hideNumber={hideNumber}
              icon={icon}
              link={
                button
                  ? button[0]?.newTabUrl || button[0].url
                  : linksArray
                  ? linksArray[i]?.url
                  : "/"
              }
              newTabLink={
                button ? button[0].newTab : linksArray && linksArray[i]?.newTab
              }
              numberColor={numberColor}
              numberIcon={numberIcon}
              substring={substring}
              title={title}
              titleColor={titleColor}
              type={type}
              button={button && button[0]}
              key={i.toString()}
            />
          );
        }
      )}
    </div>
  );
};

ColumnsRow.propTypes = {
  arr: PropTypes.array,
  linksArray: PropTypes.array,
  type: PropTypes.string,
  border: PropTypes.bool,
  amountInRow: PropTypes.number,
};

ColumnsRow.defaultProps = {
  arr: [],
  linksArray: [],
  type: "",
  border: false,
  amountInRow: 2,
};

export default ColumnsRow;
